import { Box, styled } from '@mui/material';

export const StripeRefreshPageWrapper = styled(Box)(({ theme }) => ({
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
